/* EcoFilter Ireland - Ireland's Hard Water Map 2026
   Draws the island, plots every town we have a reading for, builds the ranked table
   and wires the two together. Town facts come in on window.EF_HW_DATA (set by the
   section from the town pages' metafields); coordinates live here, keyed by page handle.
   Add a town: give it a page + menu entry (see ef-town-2026) and a line in COORDS. */
(function () {
  'use strict';

  /* ---------- coordinates by page handle ---------- */
  var COORDS = {
    'water-softener-dublin':         { lat: 53.38, lon: -6.23, label: 'North Dublin', county: 'Dublin', note: 'Leixlip supply, north and west of the city' },
    'water-softener-blanchardstown': { lat: 53.39, lon: -6.38 },
    'water-softener-swords':         { lat: 53.46, lon: -6.22 },
    'water-softener-balbriggan':     { lat: 53.61, lon: -6.18 },
    'water-softener-navan':          { lat: 53.65, lon: -6.68 },
    'water-softener-trim':           { lat: 53.55, lon: -6.79, boost: 0.5, note: 'Readings around Trim run from 355 up to 380 mg/L, the highest on the map.' },
    'water-softener-kells':          { lat: 53.73, lon: -6.88 },
    'water-softener-ashbourne':      { lat: 53.51, lon: -6.40 },
    'water-softener-drogheda':       { lat: 53.72, lon: -6.35 },
    'water-softener-dundalk':        { lat: 54.00, lon: -6.40 },
    'water-softener-naas':           { lat: 53.22, lon: -6.66 },
    'water-softener-newbridge':      { lat: 53.18, lon: -6.80 },
    'water-softener-maynooth':       { lat: 53.38, lon: -6.59 },
    'water-softener-mullingar':      { lat: 53.53, lon: -7.34 },
    'water-softener-athlone':        { lat: 53.42, lon: -7.94 },
    'water-softener-tullamore':      { lat: 53.27, lon: -7.49 },
    'water-softener-portlaoise':     { lat: 53.03, lon: -7.30 },
    'water-softener-carlow':         { lat: 52.84, lon: -6.93 },
    'water-softener-kilkenny':       { lat: 52.65, lon: -7.25 },
    'water-softener-gorey':          { lat: 52.68, lon: -6.29 },
    'water-softener-wexford':        { lat: 52.34, lon: -6.46 },
    'water-softener-waterford':      { lat: 52.26, lon: -7.11 },
    'water-softener-dungarvan':      { lat: 52.09, lon: -7.62 },
    'water-softener-clonmel':        { lat: 52.35, lon: -7.70 },
    'water-softener-thurles':        { lat: 52.68, lon: -7.81 },
    'water-softener-nenagh':         { lat: 52.86, lon: -8.20 },
    'water-softener-limerick':       { lat: 52.66, lon: -8.63 },
    'water-softener-ennis':          { lat: 52.84, lon: -8.98 },
    'water-softener-shannon':        { lat: 52.70, lon: -8.87 },
    'water-softener-galway':         { lat: 53.27, lon: -9.05 },
    'water-softener-tuam':           { lat: 53.51, lon: -8.85 },
    'water-softener-loughrea':       { lat: 53.20, lon: -8.57 },
    'water-softener-ballinasloe':    { lat: 53.33, lon: -8.22 },
    'water-softener-cork':           { lat: 51.90, lon: -8.47 },
    'water-softener-mallow':         { lat: 52.13, lon: -8.64 },
    'water-softener-monaghan':       { lat: 54.25, lon: -6.97 },
    'water-softener-carrickmacross': { lat: 53.98, lon: -6.72 },
    'water-softener-co-cavan':       { lat: 53.99, lon: -7.36, label: 'Cavan town', county: 'Co. Cavan' }
  };

  /* Readings that have no page of their own but belong on the map (supply-zone splits) */
  var EXTRAS = [
    { handle: 'x-south-dublin', name: 'South Dublin', county: 'Dublin', lat: 53.29, lon: -6.19, h: 50,
      src: 'Uisce Éireann figure for the Ballymore Eustace and Vartry supplies', url: '/pages/water-softener-dublin',
      note: 'Ballymore Eustace and Vartry supply, south of the Liffey. Soft, no softener needed.' },
    { handle: 'x-west-dublin', name: 'West Dublin (D10, 12, 20, 22)', county: 'Dublin', lat: 53.33, lon: -6.38, h: 155,
      src: 'Uisce Éireann figure for the blended supply', url: '/pages/water-softener-dublin',
      note: 'A blend of Leixlip and Ballymore Eustace water.' },
    { handle: 'x-kingscourt', name: 'Kingscourt', county: 'Co. Cavan', lat: 53.91, lon: -6.81, h: 150,
      src: 'Regional estimate for the Kingscourt borehole', url: '/pages/water-softener-co-cavan' }
  ];

  /* ---------- coastline (lat, lon), clockwise from Malin Head ---------- */
  var COAST = [
    [55.38,-7.37],[55.28,-7.15],[55.20,-6.95],[55.21,-6.70],[55.24,-6.45],[55.22,-6.25],[55.22,-6.14],[55.12,-6.05],
    [54.97,-5.95],[54.85,-5.80],[54.75,-5.70],[54.68,-5.78],[54.66,-5.66],[54.64,-5.53],[54.50,-5.47],[54.38,-5.48],
    [54.30,-5.55],[54.24,-5.62],[54.20,-5.80],[54.12,-5.92],[54.06,-6.00],[54.02,-6.10],[54.00,-6.22],[53.95,-6.30],
    [53.87,-6.24],[53.80,-6.22],[53.73,-6.22],[53.65,-6.16],[53.58,-6.09],[53.48,-6.08],[53.42,-6.06],[53.38,-6.06],
    [53.34,-6.18],[53.30,-6.13],[53.27,-6.09],[53.20,-6.08],[53.10,-6.03],[52.98,-5.99],[52.88,-6.05],[52.79,-6.14],
    [52.68,-6.22],[52.56,-6.19],[52.45,-6.23],[52.33,-6.37],[52.25,-6.33],[52.17,-6.36],[52.16,-6.50],[52.17,-6.59],
    [52.13,-6.78],[52.12,-6.93],[52.15,-6.99],[52.14,-7.15],[52.08,-7.40],[52.00,-7.57],[51.95,-7.84],[51.86,-7.95],
    [51.83,-8.01],[51.80,-8.15],[51.79,-8.25],[51.72,-8.40],[51.62,-8.53],[51.57,-8.72],[51.53,-8.95],[51.50,-9.15],
    [51.47,-9.37],[51.45,-9.60],[51.45,-9.82],[51.52,-9.70],[51.55,-9.85],[51.60,-9.70],[51.66,-9.90],[51.60,-10.20],
    [51.70,-10.05],[51.78,-10.00],[51.80,-10.25],[51.88,-10.40],[51.95,-10.20],[52.05,-9.90],[52.10,-10.10],[52.10,-10.45],
    [52.20,-10.35],[52.27,-10.17],[52.27,-9.95],[52.27,-9.86],[52.35,-9.80],[52.42,-9.95],[52.50,-9.85],[52.56,-9.93],
    [52.62,-9.70],[52.68,-9.65],[52.80,-9.50],[52.94,-9.47],[53.05,-9.35],[53.15,-9.27],[53.20,-9.10],[53.27,-9.05],
    [53.24,-9.30],[53.27,-9.55],[53.30,-9.70],[53.33,-9.83],[53.38,-10.05],[53.40,-10.23],[53.49,-10.08],[53.56,-10.15],
    [53.60,-9.95],[53.62,-9.90],[53.70,-9.85],[53.76,-9.80],[53.80,-9.60],[53.85,-9.75],[53.92,-9.95],[53.97,-10.25],
    [54.05,-10.15],[54.10,-9.95],[54.18,-10.05],[54.30,-10.00],[54.33,-9.80],[54.28,-9.55],[54.22,-9.20],[54.25,-9.00],
    [54.30,-8.70],[54.30,-8.60],[54.40,-8.55],[54.47,-8.45],[54.52,-8.25],[54.60,-8.18],[54.63,-8.35],[54.62,-8.55],
    [54.70,-8.80],[54.80,-8.75],[54.85,-8.55],[54.95,-8.45],[55.05,-8.35],[55.15,-8.30],[55.20,-8.10],[55.22,-7.98],
    [55.17,-7.80],[55.28,-7.63],[55.20,-7.52],[55.30,-7.45],[55.38,-7.37]
  ];

  /* ---------- projection ---------- */
  var COSLAT = 0.595, K = 150, X0 = 20, Y0 = 15, LON0 = -10.55, LAT0 = 55.45;
  function px(lon) { return X0 + (lon - LON0) * COSLAT * K; }
  function py(lat) { return Y0 + (LAT0 - lat) * K; }

  /* Greater Dublin inset, drawn into a box on the right */
  var INS = { x: 474, y: 205, w: 218, h: 250, lon0: -7.0, lon1: -5.85, lat0: 53.12, lat1: 53.80 };
  INS.kx = INS.w / ((INS.lon1 - INS.lon0) * COSLAT);
  INS.ky = INS.h / (INS.lat1 - INS.lat0);
  function ipx(lon) { return INS.x + (lon - INS.lon0) * COSLAT * INS.kx; }
  function ipy(lat) { return INS.y + (INS.lat1 - lat) * INS.ky; }
  function inInset(t) { return t.lon > INS.lon0 && t.lon < INS.lon1 && t.lat > INS.lat0 && t.lat < INS.lat1; }

  function smoothPath(pts) {
    /* Catmull-Rom through the points, closed */
    var n = pts.length - 1, d = 'M' + pts[0][0].toFixed(1) + ' ' + pts[0][1].toFixed(1);
    for (var i = 0; i < n; i++) {
      var p0 = pts[(i - 1 + n) % n], p1 = pts[i], p2 = pts[(i + 1) % n], p3 = pts[(i + 2) % n];
      var c1x = p1[0] + (p2[0] - p0[0]) / 6, c1y = p1[1] + (p2[1] - p0[1]) / 6;
      var c2x = p2[0] - (p3[0] - p1[0]) / 6, c2y = p2[1] - (p3[1] - p1[1]) / 6;
      d += 'C' + c1x.toFixed(1) + ' ' + c1y.toFixed(1) + ' ' + c2x.toFixed(1) + ' ' + c2y.toFixed(1) + ' ' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
    }
    return d + 'Z';
  }

  function band(h) {
    if (h >= 300) return { key: 'vhard', name: 'Very hard', col: 'var(--vhard)' };
    if (h >= 200) return { key: 'hard', name: 'Hard', col: 'var(--hard)' };
    if (h >= 100) return { key: 'mod', name: 'Moderately hard', col: 'var(--mod)' };
    return { key: 'soft', name: 'Soft', col: 'var(--soft)' };
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function isEstimate(src) { return /estimate|regional/i.test(src || ''); }

  /* ---------- build the dataset ---------- */
  function buildTowns(raw) {
    var out = [], seen = {};
    (raw || []).forEach(function (r) {
      var c = COORDS[r.handle]; if (!c) return;
      var h = parseInt(r.h, 10); if (!(h >= 0)) return;
      var name = c.label || r.name;
      if (seen[name]) return; seen[name] = 1;
      out.push({ handle: r.handle, name: name, county: c.county || r.county || '', lat: c.lat, lon: c.lon, h: h, boost: c.boost || 0, src: r.src || '', url: r.url, supply: r.supply || '', note: c.note || '' });
    });
    EXTRAS.forEach(function (e) { if (!seen[e.name]) { seen[e.name] = 1; out.push(e); } });
    out.forEach(function (t) { t.band = band(t.h); t.est = isEstimate(t.src); });
    out.sort(function (a, b) { return (b.h + (b.boost || 0)) - (a.h + (a.boost || 0)) || a.name.localeCompare(b.name); });
    out.forEach(function (t, i) { t.rank = i + 1; });
    return out;
  }

  /* ---------- map ---------- */
  function drawMap(svg, towns, opts) {
    opts = opts || {};
    var W = 700, H = 640;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var pts = COAST.map(function (p) { return [px(p[1]), py(p[0])]; });
    var path = smoothPath(pts);
    var ipts = COAST.map(function (p) { return [ipx(p[1]), ipy(p[0])]; });
    var ipath = smoothPath(ipts);
    var html = '';
    html += '<defs><clipPath id="efhw-ins-clip"><rect x="' + INS.x + '" y="' + INS.y + '" width="' + INS.w + '" height="' + INS.h + '" rx="10"/></clipPath>' +
      '<filter id="efhw-shadow" x="-10%" y="-10%" width="120%" height="120%"><feDropShadow dx="0" dy="6" stdDeviation="8" flood-color="#143a52" flood-opacity=".18"/></filter></defs>';
    html += '<path class="efhw-land" d="' + path + '" filter="url(#efhw-shadow)"/>';
    /* inset frame + land */
    html += '<g class="efhw-inset">';
    html += '<rect class="efhw-inset-bg" x="' + INS.x + '" y="' + INS.y + '" width="' + INS.w + '" height="' + INS.h + '" rx="10"/>';
    html += '<g clip-path="url(#efhw-ins-clip)"><path class="efhw-land efhw-land--inset" d="' + ipath + '"/></g>';
    html += '<rect class="efhw-inset-frame" x="' + INS.x + '" y="' + INS.y + '" width="' + INS.w + '" height="' + INS.h + '" rx="10"/>';
    html += '<text class="efhw-inset-title" x="' + (INS.x + 10) + '" y="' + (INS.y - 8) + '">Greater Dublin, zoomed in</text>';
    /* connector from the Dublin box on the main map to the inset */
    var bx0 = px(INS.lon0), by0 = py(INS.lat1), bx1 = px(INS.lon1), by1 = py(INS.lat0);
    html += '<rect class="efhw-zoombox" x="' + bx0.toFixed(1) + '" y="' + by0.toFixed(1) + '" width="' + (bx1 - bx0).toFixed(1) + '" height="' + (by1 - by0).toFixed(1) + '" rx="3"/>';
    html += '<line class="efhw-zoomline" x1="' + bx1.toFixed(1) + '" y1="' + by0.toFixed(1) + '" x2="' + INS.x + '" y2="' + INS.y + '"/>';
    html += '<line class="efhw-zoomline" x1="' + bx1.toFixed(1) + '" y1="' + by1.toFixed(1) + '" x2="' + INS.x + '" y2="' + (INS.y + INS.h) + '"/>';
    html += '</g>';
    /* dots */
    var labelOn = { 'Cork city': 1, 'Galway city': 1, 'Limerick city': 1, 'Waterford': 1, 'Dundalk': 1, 'Athlone': 1, 'Kilkenny': 1, 'Monaghan': 1, 'Cavan town': 1, 'Wexford': 1, 'Ennis': 1, 'Mullingar': 1, 'Clonmel': 1, 'Portlaoise': 1, 'Mallow': 1 };
    var insetLabels = { 'North Dublin': 1, 'South Dublin': 1, 'Swords': 1, 'Balbriggan': 1, 'Navan': 1, 'Trim': 1, 'Kells': 1, 'Drogheda': 1, 'Naas': 1, 'Newbridge': 1, 'Maynooth': 1, 'Ashbourne': 1, 'Blanchardstown': 1 };
    html += '<g class="efhw-dots">';
    towns.forEach(function (t, i) {
      var inset = inInset(t);
      var r = inset ? 4.5 : 7;
      var x = px(t.lon), y = py(t.lat);
      html += '<g class="efhw-dot efhw-dot--' + t.band.key + (inset ? ' efhw-dot--small' : '') + '" data-h="' + esc(t.handle) + '" style="--i:' + i + '" tabindex="0" role="button" aria-label="' + esc(t.name + ', ' + t.h + ' mg/L, ' + t.band.name) + '">' +
        '<circle class="efhw-halo" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + (r + 7) + '"/>' +
        '<circle class="efhw-pin" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + r + '"/>' +
        (labelOn[t.name] && !inset ? '<text class="efhw-lbl" x="' + (x + r + 4).toFixed(1) + '" y="' + (y + 4).toFixed(1) + '">' + esc(t.name.replace(' city', '')) + '</text>' : '') +
        '</g>';
    });
    html += '</g><g class="efhw-dots efhw-dots--inset" clip-path="url(#efhw-ins-clip)">';
    var lbls = '';
    towns.filter(inInset).forEach(function (t, i) {
      var x = ipx(t.lon), y = ipy(t.lat), r = 7;
      var lx = x + r + 4, anchor = 'start', ly = y + 4;
      if (/Balbriggan|Maynooth|Newbridge|Trim/.test(t.name)) { lx = x - r - 4; anchor = 'end'; }
      if (/Blanchardstown/.test(t.name)) { ly = y - 9; }
      if (/West Dublin/.test(t.name)) { ly = y + 17; lx = x; anchor = 'middle'; }
      if (/South Dublin/.test(t.name)) { ly = y + 16; lx = x + 2; anchor = 'start'; }
      if (/Ashbourne/.test(t.name)) { ly = y - 8; }
      if (/Swords/.test(t.name)) { ly = y - 2; }
      html += '<g class="efhw-dot efhw-dot--' + t.band.key + '" data-h="' + esc(t.handle) + '" style="--i:' + i + '" tabindex="0" role="button" aria-label="' + esc(t.name + ', ' + t.h + ' mg/L, ' + t.band.name) + '">' +
        '<circle class="efhw-halo" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + (r + 7) + '"/>' +
        '<circle class="efhw-pin" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + r + '"/></g>';
      if (insetLabels[t.name] || /West Dublin/.test(t.name)) {
        lbls += '<text class="efhw-lbl efhw-lbl--inset" text-anchor="' + anchor + '" x="' + lx.toFixed(1) + '" y="' + ly.toFixed(1) + '">' + esc(/West Dublin/.test(t.name) ? 'West Dublin' : t.name) + '</text>';
      }
    });
    html += '</g><g class="efhw-lbls">' + lbls + '</g>';
    if (opts.credit) {
      html += '<text class="efhw-credit" x="' + (W - 12) + '" y="' + (H - 14) + '" text-anchor="end">' + esc(opts.credit) + '</text>';
    }
    svg.innerHTML = html;
  }

  /* ---------- table ---------- */
  function renderTable(tbody, towns, filter) {
    var q = (filter.q || '').toLowerCase().trim(), b = filter.band || 'all';
    var rows = towns.filter(function (t) {
      if (b !== 'all' && t.band.key !== b) return false;
      if (q && (t.name + ' ' + t.county).toLowerCase().indexOf(q) < 0) return false;
      return true;
    });
    var max = 400;
    tbody.innerHTML = rows.map(function (t) {
      var pct = Math.min(100, Math.round(t.h / max * 100));
      return '<tr data-h="' + esc(t.handle) + '" class="efhw-row efhw-row--' + t.band.key + '" tabindex="0">' +
        '<td class="efhw-td-rank">' + t.rank + '</td>' +
        '<td class="efhw-td-name"><a href="' + esc(t.url) + '">' + esc(t.name) + '</a><small>' + esc(t.county) + '</small></td>' +
        '<td class="efhw-td-bar"><span class="efhw-track"><i style="--w:' + pct + '%;background:' + t.band.col + '"></i></span></td>' +
        '<td class="efhw-td-val"><b>' + t.h + '</b><small>mg/L</small></td>' +
        '<td class="efhw-td-band"><span class="efhw-pill efhw-pill--' + t.band.key + '">' + t.band.name + '</span>' + (t.est ? '<em class="efhw-est" title="Regional estimate, not an Uisce Éireann zone reading">est.</em>' : '') + '</td>' +
        '</tr>';
    }).join('') || '<tr><td colspan="5" class="efhw-empty">No town matches that. Try a county name.</td></tr>';
    return rows.length;
  }

  /* ---------- tooltip ---------- */
  function tooltipHtml(t) {
    return '<b>' + esc(t.name) + '</b><span class="efhw-tip-county">' + esc(t.county) + '</span>' +
      '<div class="efhw-tip-read"><strong style="color:' + t.band.col + '">' + t.h + '</strong> mg/L <em class="efhw-pill efhw-pill--' + t.band.key + '">' + t.band.name + '</em></div>' +
      (t.note ? '<p>' + esc(t.note) + '</p>' : (t.supply ? '<p>Supply: ' + esc(t.supply.charAt(0).toUpperCase() + t.supply.slice(1).replace(/\.$/, '')) + '.</p>' : '')) +
      '<small>' + esc(t.src) + '</small>' +
      (t.url ? '<a href="' + esc(t.url) + '">Softeners in ' + esc(t.name.replace(/ \(.*\)$/, '')) + ' &rarr;</a>' : '');
  }

  /* ---------- headline stats ---------- */
  function renderStats(root, towns) {
    var hard = towns.filter(function (t) { return t.h >= 200; }).length;
    var top = towns[0], soft = towns.slice().sort(function (a, b) { return a.h - b.h; })[0];
    var el;
    if ((el = root.querySelector('[data-stat=hardest]'))) el.innerHTML = '<b>' + esc(top.name) + '</b><span>' + top.h + ' mg/L, ' + esc(top.county) + '</span>';
    if ((el = root.querySelector('[data-stat=softest]'))) el.innerHTML = '<b>' + esc(soft.name) + '</b><span>' + soft.h + ' mg/L, ' + esc(soft.county) + '</span>';
    if ((el = root.querySelector('[data-stat=share]'))) el.innerHTML = '<b>' + hard + ' of ' + towns.length + '</b><span>places on the map are hard or very hard (200 mg/L and over)</span>';
    if ((el = root.querySelector('[data-stat=count]'))) el.textContent = towns.length;
  }

  /* ---------- wire it all up ---------- */
  function init() {
    var root = document.querySelector('[data-efhw]'); if (!root) return;
    var towns = buildTowns(window.EF_HW_DATA);
    var svg = root.querySelector('svg.efhw-svg');
    var tbody = root.querySelector('.efhw-table tbody');
    var tip = root.querySelector('.efhw-tip');
    var count = root.querySelector('[data-count]');
    var filter = { q: '', band: 'all' };
    var byHandle = {}; towns.forEach(function (t) { byHandle[t.handle] = t; });

    drawMap(svg, towns, {});
    renderStats(root, towns);
    var n = renderTable(tbody, towns, filter);
    if (count) count.textContent = n;
    window.EF_HW_TOWNS = towns;

    /* filters */
    root.querySelectorAll('[data-band]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-band]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        filter.band = btn.getAttribute('data-band');
        var m = renderTable(tbody, towns, filter); if (count) count.textContent = m;
        svg.querySelectorAll('.efhw-dot').forEach(function (d) {
          var t = byHandle[d.getAttribute('data-h')];
          d.classList.toggle('is-dim', filter.band !== 'all' && t.band.key !== filter.band);
        });
      });
    });
    var search = root.querySelector('[data-search]');
    if (search) search.addEventListener('input', function () {
      filter.q = search.value;
      var m = renderTable(tbody, towns, filter); if (count) count.textContent = m;
      var q = filter.q.toLowerCase().trim();
      svg.querySelectorAll('.efhw-dot').forEach(function (d) {
        var t = byHandle[d.getAttribute('data-h')];
        d.classList.toggle('is-dim', !!q && (t.name + ' ' + t.county).toLowerCase().indexOf(q) < 0);
      });
    });

    /* hover / focus linking */
    var active = null;
    function setActive(h, from) {
      if (active) {
        svg.querySelectorAll('.efhw-dot[data-h="' + active + '"]').forEach(function (d) { d.classList.remove('is-on'); });
        var r0 = tbody.querySelector('tr[data-h="' + active + '"]'); if (r0) r0.classList.remove('is-on');
      }
      active = h;
      if (!h) { tip.hidden = true; return; }
      var dots = svg.querySelectorAll('.efhw-dot[data-h="' + h + '"]');
      dots.forEach(function (d) { d.classList.add('is-on'); });
      var row = tbody.querySelector('tr[data-h="' + h + '"]'); if (row) { row.classList.add('is-on'); if (from === 'map') row.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
      var t = byHandle[h];
      tip.innerHTML = tooltipHtml(t);
      tip.hidden = false;
      /* place the tip beside the big dot (inset one if there is one, else the main one) */
      var d = dots[dots.length - 1]; var pin = d && d.querySelector('.efhw-pin');
      if (pin) {
        var pr = pin.getBoundingClientRect(), rr = root.querySelector('.efhw-map').getBoundingClientRect();
        var x = pr.left - rr.left + pr.width / 2, y = pr.top - rr.top;
        var mw = rr.width; var tw = Math.min(280, mw - 16);
        tip.style.width = tw + 'px';
        var left = x + 14; if (left + tw > mw - 8) left = x - tw - 14; if (left < 8) left = 8;
        tip.style.left = left + 'px';
        tip.style.top = Math.max(8, y - 10) + 'px';
      }
    }
    svg.addEventListener('mouseover', function (e) { var d = e.target.closest('.efhw-dot'); if (d) setActive(d.getAttribute('data-h'), 'map'); });
    svg.addEventListener('focusin', function (e) { var d = e.target.closest('.efhw-dot'); if (d) setActive(d.getAttribute('data-h'), 'map'); });
    svg.addEventListener('click', function (e) { var d = e.target.closest('.efhw-dot'); if (d) { e.preventDefault(); setActive(d.getAttribute('data-h'), 'map'); } });
    svg.addEventListener('mouseleave', function () { if (!root.classList.contains('is-touch')) setActive(null); });
    tbody.addEventListener('mouseover', function (e) { var r = e.target.closest('tr[data-h]'); if (r) setActive(r.getAttribute('data-h'), 'table'); });
    tbody.addEventListener('focusin', function (e) { var r = e.target.closest('tr[data-h]'); if (r) setActive(r.getAttribute('data-h'), 'table'); });
    tbody.addEventListener('mouseleave', function () { setActive(null); });
    root.addEventListener('touchstart', function () { root.classList.add('is-touch'); }, { passive: true });
    document.addEventListener('click', function (e) { if (!e.target.closest('.efhw-dot') && !e.target.closest('.efhw-tip')) setActive(null); });

    /* embed code copy */
    var copyBtn = root.querySelector('[data-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var ta = root.querySelector('[data-embed]');
      var txt = ta.value || ta.textContent;
      (navigator.clipboard ? navigator.clipboard.writeText(txt) : Promise.reject()).then(function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy the embed code'; }, 1800); }, function () { ta.select(); });
    });

    /* dots pop in */
    requestAnimationFrame(function () { root.classList.add('is-ready'); });
  }

  window.EFHW = { buildTowns: buildTowns, drawMap: drawMap, band: band };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
